import React, { Component } from "react";
import toastr from 'toastr'
import {
    Link
} from "react-router-dom";

import {
    NotificationContainer,
    NotificationManager
} from "react-notifications";
import { Validation } from "app/_helpers/validation/Validation";
import { CountryService } from "app/_services/ConfigService/CountryService/CountryService";
import { Constant } from "./Constant";
import Prompt from 'app/Components/IEnergyPrompt/Prompt'
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import SimpleSelect from 'app/Components/SearchableSelect/SimpleSelect'
class AddCountry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            status: '',
            error: {},
            countryId: this.props.match.params.id ? this.props.match.params.id : "",
            // projectId: this.props.match.params.projectId ? this.props.match.params.projectId : "",
            // projectData: {},
            submitted: false,
            edit: false,
            changeRoute: ''
        }
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        // this.setProjectDetails();
        console.log('this.state.id', this.state.id)
        if (this.state.countryId) {
            this.setCountryData(this.state.countryId);
            this.setState({
                edit: true
            })
        }
    }

    async setCountryData(countryId) {
        let response = await CountryService.getCountryByID(this.state.projectId, countryId);

        if (response && response.status) {
            if (response.data && response.data) {
                let countryData = response.data;
                this.setState({
                    countryData: countryData,
                    name: countryData.name,
                    status: countryData.activeStatus
                })
            }
        } else {
            NotificationManager.info('No Record Found')
            this.props.history.push('/');
        }

    }

    // async setProjectDetails() {
    //     let response = await ProjectService.projectDetailsByID(this.state.projectId);

    //     if (response && response.status) {
    //         if (response.data && response.data) {
    //             this.setState({
    //                 projectData: response.data
    //             })
    //         }
    //     } else {
    //         toastr.info('No Record Found')
    //         this.props.history.push('/');
    //     }
    // }

    handleInputChange = (e) => {
        const { name, value } = e.target;


        this.setState({
            [name]: value,
            changeRoute: 1
        }, () => {
            this.checkValidation();
            console.log('state', this.state)
        });
    }

    /**********************Validation ***************/
    checkValidation() {
        this.setState({
            changeRoute: 1
        })
        if (this.state.submitted) {
            var errobj = {};

            /**call validation file for validation */
            errobj = Validation(this.state, Constant.countryCustomField);


            this.setState({ error: errobj, submitted: true });
        }
    }

    async onSubmit(e) {
        // e.preventDefault();
        var errobj = {};

        /**call validation file for validation */
        errobj = Validation(this.state, Constant.countryCustomField);


        this.setState({ error: errobj, submitted: true });
        /**
         * final checking for any error exists or not
         */
        var flag = 0;
        Object.keys(errobj).map(index => {
            if (errobj[index] !== "") {
                flag = 1;
            }
        });

        console.log('flag', flag)
        if (flag === 0) {

            let obj = {
                "name": this.state.name,
                "activeStatus": this.state.status,
                // "project_id": this.state.projectId
            }

            let data = {};

            if (this.state.edit) {
                data = await CountryService.updateCountry(this.state.projectId, this.state.countryId, obj);
            } else {
                data = await CountryService.createCountry(this.state.projectId, obj);
            }

            if (data && data.status === 1) {
                this.setState({
                    changeRoute: ''
                })
                if (this.state.edit) {
                    toastr.success('Country Updated')
                    // NotificationManager.success('Country Updated')
                    this.props.history.push("/global-configuration/project-details/country");
                } else {
                    // NotificationManager.success('Country Created')
                    toastr.success('Country Created')
                    this.props.history.push("/global-configuration/project-details/country");
                }
            } else if (data && data.message) {
                // NotificationManager.warning(data.message)
                toastr.warning(data.message)
            }

        }

    }

    render() {
        const {
            name,
            status,
            projectData,
            projectId,
            edit
        } = this.state;
        return (
            <div>
                <MainBreadcrumb
                    routeSegments={[
                        // { name: projectData.name, path: "/project/" + projectId + "/dashboard" },
                        // { name: "Configuration", path: "#" },
                        { name: "Global Settings", path: "#" },
                        { name: "Country", path: "/project/" + projectId + "/configuration/project-details/country" },
                        { name: edit ? 'Edit' : 'Add' }
                    ]}
                    // imageSrc={projectData && projectData.document && projectData.document.document_name ? projectData.document.document_name : ''}
                    // description={projectData && projectData.descriptionDisplay ? projectData.descriptionDisplay : ''}
                    breadCrumbsText="Configuration_Project_Details_Country"
                />
                <Prompt changes={this.state.changeRoute}></Prompt>
                <div className="row d-flex justify-content-center">
                    <div className="col-md-5">
                        <div className="card mt-4 mb-3">
                            <div className="card-body">
                                <div className="simple-card-title">
                                    <h3 class="text-capitalize mb-1">{edit ? 'Edit' : 'Add'} Country</h3>

                                </div>
                                <>
                                    <div className="row">
                                        <div className="col-md-12 form-group mb-3">
                                            <label>Country</label>
                                            <input
                                                name="name"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Country Name"
                                                value={name}
                                                onChange={e => this.handleInputChange(e)}
                                            />
                                            {this.state.submitted && this.state.error.name !== "" && (
                                                <div className="fromerror">{this.state.error.name}</div>)}
                                        </div>


                                        <div className="col-md-12 form-group mb-3">
                                            <label>Status</label>
                                            {/* <select
                                                name="status"
                                                className="form-control"
                                                value={status}
                                                onChange={e => this.handleInputChange(e)}
                                            >
                                                <option value="">Select Status</option>
                                                <option value={1}>Active</option>
                                                <option value={2}>In-active</option>
                                            </select> */}

                                            <SimpleSelect
                                                name="status"
                                                className="form-control"
                                                value={status}
                                                onChange={e => this.handleInputChange(e)}
                                                id="id"
                                                label="name"
                                                options={[
                                                    { id: 1, name: 'Active' },
                                                    { id: 2, name: 'In-active' },
                                                ]}
                                                init="Select Status"
                                            ></SimpleSelect>

                                            {this.state.submitted && this.state.error.status !== "" && (
                                                <div className="fromerror">{this.state.error.status}</div>)}
                                        </div>
                                        <div className="col-md-12">
                                        </div>
                                        <div className="col-md-12 text-center">
                                            <Link
                                                to={"/global-configuration/project-details/country"}
                                                className="btn btn-secondary mr-2"
                                            >Back</Link>
                                            <button onClick={() => this.onSubmit()}
                                                className="btn btn-primary ml-2"
                                            >{edit ? 'Update' : 'Submit'}</button>
                                        </div>
                                    </div>
                                </>
                            </div>
                        </div>
                    </div>
                </div>
                <NotificationContainer />
            </div>
        )
    }
}

export default AddCountry
